module.exports = __webpack_public_path__ + "static/media/truck.13039933.svg";